import { useSession } from 'next-auth/react'
import { useMemo } from 'react'
import { analytics } from './client'
import { getMultiOrgUserTrackingId } from './getMultiOrgUserTrackingId'
// oxlint-disable-next-line import/no-empty-named-blocks -- Load NextAuth type augmentation without a runtime import.
import type {} from '@omnea-app/fe-auth/nextAuthOverrides'

export const useIdentifyUser = () => {
  const { data: session } = useSession()

  // Identify synchronously before rendering consumers that may emit analytics events.
  useMemo(() => {
    if (!session) return

    const { email } = session.user

    if (session.user.type === 'organisationPicker') {
      const id = getMultiOrgUserTrackingId(email)
      void analytics.then((analytics) => analytics.identify(id, { email }))
      return
    }

    const { id, firstName, lastName, role, hmac } = session.user.metadata
    const { organisationId, name, isQaOrg } = session.user.orgMetadata

    void analytics.then((analytics) =>
      analytics.identify(id, {
        email,
        role,
        firstName,
        lastName,
        organisationId,
        organisationName: name,
        isQaOrg,
        userId: id,
        user_hash: hmac?.pylonUserHash || undefined,
      })
    )
    void analytics.then((analytics) => analytics.group(organisationId, { name }))
  }, [session])
}
